module.exports = __webpack_public_path__ + "static/media/ic_close.42e2e234.png";